module.exports = __webpack_public_path__ + "img/首页H5产品轮播图1.60544812.png";